import React from 'react';
import { Field } from 'formik';
import { MenuProps, Props } from './multiSelect.type';
import ReactSelect from 'components/base/ReactSelect';
import { getValueByPath } from 'helpers/utils';

type Value = {
  label: string;
  value: string;
};

function MultipleSelect({ field, form, options, ...props }: MenuProps) {
  const handleChange = (values: unknown) => {
    const formValues = values as Value[];
    form.setFieldValue(
      field.name,
      formValues.map(({ value }) => value)
    );
  };
  const value = options?.filter(item => field.value?.includes(item.value));

  const errorMessage = getValueByPath(form.errors, field.name);

  const isError = Boolean(
    errorMessage && getValueByPath(form.touched, field.name)
  );

  return (
    <>
      <ReactSelect
        value={value}
        options={options}
        {...props}
        isMulti
        onChange={handleChange}
        isInvalid={isError}
      />
      {isError && typeof errorMessage === 'string' && (
        <div className="invalid-feedback d-block">{errorMessage}</div>
      )}
    </>
  );
}

export default function MultiSelect(props: Props) {
  return <Field {...props} component={MultipleSelect} />;
}
